export const getSectionInitialData = <T>(currentData: T | undefined, emptyData: T) => {
  return currentData ? currentData : emptyData
}
